import { Component } from '@angular/core';
import {  RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuBarComponent } from './components/side-menu-bar/side-menu-bar.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,
    // HeaderComponent,
    // SideMenuBarComponent,
    // DashboardComponent,
    
    (MatCardModule)],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent  {
  title = 'merck-game-plan-frontend';
}